import * as React from 'react';

import {Pillset} from 'shells/entity-pill/pillset';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {TextfieldWithApply} from 'shells/textfield/textfield-with-apply';
import {Body} from 'shells/typography/body';
import {MarketingTitle} from 'shells/typography/marketing-title';
import {ModalTitle} from 'shells/typography/modal-title';

import {GetEmailBlocklist} from './get-email-blocklist';

import styles from './email-blocklist.module.css';

type Props = {
    onError: (arg1: string) => void;
};

export function EmailBlocklist(props: Props) {
    return (
        <GetEmailBlocklist>
            {({isLoading, isUpdating, blocklistedEmails, addToBlocklist, removeFromBlocklist}) => {
                const disabled = isLoading || isUpdating;

                const handleSaveEmail = (newEmailAddress: string) =>
                    addToBlocklist(newEmailAddress).catch((error) => {
                        props.onError(error);
                    });

                return (
                    <React.Fragment>
                        <SpacerGroup>
                            <MarketingTitle>Your blocklisted addresses</MarketingTitle>
                            {/* @ts-expect-error */}
                            <Pillset
                                values={blocklistedEmails}
                                emptyState={<Body as='i'>No blocklisted email addresses</Body>}
                                onRemove={(emailAddress) => {
                                    removeFromBlocklist(emailAddress).catch((error) => {
                                        props.onError(error);
                                    });
                                }}
                            />
                        </SpacerGroup>
                        <ModalTitle>Block an email address</ModalTitle>
                        <div className={styles['add-email-container']}>
                            <TextfieldWithApply
                                buttonText='Block address'
                                placeholder='mom@hotmail.com'
                                disabled={disabled}
                                onApply={handleSaveEmail}
                            />
                        </div>
                    </React.Fragment>
                );
            }}
        </GetEmailBlocklist>
    );
}
